import './index.scss'

export default function CheckIcon(props: { value?: boolean }) {
  return <div className={props.value ? 'checked-icon cursor-pointer' : 'check-icon cursor-pointer'}></div>
}
